import React, { Fragment } from 'react';
import { Modal, Icon } from 'grab-ui';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEmpty } from 'common/utils/data-utils';
import { ACTION } from 'constants/history-constants';

import css from './msd-tracking-modal.less';

const MSDTrackingModal = ({ trackingURLsMap, visible, handleClose }) => {
  const onClickTrackDelivery = urlMap => {
    const { webTrackingURL } = urlMap;
    if (webTrackingURL) {
      window.open(webTrackingURL);
    }
  };

  return (
    <div className={css.modalContainer}>
      <Modal
        className={css.modalContainer}
        centered
        visible={visible}
        onCancel={handleClose}
        onOk={handleClose}
        maskStyle={{ backgroundColor: 'rgba(28, 28, 28, 0.5)' }}
        cancelText={I18n.t('v2.commonButton.cancel')}
        okText={I18n.t('v2.commonButton.ok')}
      >
        <div className={css.content}>
          {trackingURLsMap.map((urlMap, index) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={`tracking-${index}`}
              tabIndex={0}
              onKeyPress={null}
              role="button"
              onClick={() => onClickTrackDelivery(urlMap)}
              className={css.trackingRecord}
            >
              <h5>{urlMap.orderID}</h5>
              <div
                className={classnames({
                  [css.iconContainer]: true,
                  [css.iconActive]: !isEmpty(urlMap.webTrackingURL),
                  [css.iconInactive]: isEmpty(urlMap.webTrackingURL),
                })}
              >
                {!isEmpty(urlMap.webTrackingURL) ? (
                  <Fragment>
                    <Icon className={css.actionIcons} type="environment" />
                    <span>{I18n.t(ACTION.TRACK_ORDER)}</span>
                  </Fragment>
                ) : (
                  <span>{I18n.t('history.table.expired')}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
};

MSDTrackingModal.propTypes = {
  trackingURLsMap: PropTypes.arrayOf(
    PropTypes.shape({
      orderID: PropTypes.string,
      webTrackingURL: PropTypes.string,
    }),
  ).isRequired,
  visible: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

MSDTrackingModal.defaultProps = {
  trackingURLsMap: [
    {
      orderID: '',
      webTrackingURL: '',
    },
  ],
  visible: false,
};

export default MSDTrackingModal;
